import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ReactSVG } from 'react-svg'

import { App } from './app'
import svgIcons from '@/assets/sprite.svg'
import 'normalize.css'
import './styles/index.sass'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
    <ReactSVG src={svgIcons} />
  </StrictMode>,
)
